











































































// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';

// mapbox
import 'mapbox-gl-compare/dist/mapbox-gl-compare.css';

// primevue
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';

export default defineComponent({
    components: { 
        Dropdown, 
        Button 
    },
    props: {
        options: {
            type: Array,
            default: [],
        },
        userMosaic: {
            type: Object,
            default: () => {},
        },
        compareMapbox: {
            type: Object,
        },
        updateCompareMapboxProperty: {
            type: Function,
            default: () => {},
        },
        afterCompareLoadCallback: {
            type: Function,
            default: () => {},
        },
        layerTree: {
            type: Object,
            default: null,
        },
        updateLayerTreeProperty: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // ref
        const mosaicLeft = ref(props.userMosaic);
        const mosaicRight = ref();

        const isComparingMosaicOn = ref<boolean>(false);

        // methods
        const compareMosaic = (): void => {
            isComparingMosaicOn.value = true;
            props.afterCompareLoadCallback(true);

            // props.compareMapbox.isCompareMosaic =
            //     !props.compareMapbox.isCompareMosaic;
            // props.compareMapbox.leftMosaic = mosaicLeft.value;
            // props.compareMapbox.rightMosaic = mosaicRight.value;
            props.updateCompareMapboxProperty({
                                                isCompareMosaic: !props.compareMapbox.isCompareMosaic,
                                                leftMosaic: mosaicLeft.value,
                                                rightMosaic: mosaicRight.value
                                              })
        };

        const clearCompareMosaic = (): void => {
            if (isComparingMosaicOn.value) {
                props.afterCompareLoadCallback(false);
                isComparingMosaicOn.value = false;

                // props.compareMapbox.isCompareMosaic =
                //     !props.compareMapbox.isCompareMosaic;
                // props.compareMapbox.leftMosaic = '';
                // props.compareMapbox.rightMosaic = '';
            
                props.updateCompareMapboxProperty({
                                                isCompareMosaic: !props.compareMapbox.isCompareMosaic,
                                                leftMosaic: '',
                                                rightMosaic: ''
                                              })
            } else {
                // props.layerTree.isCompareMosaic = false;
                props.updateLayerTreeProperty(false);
            }
        };

        const assignMosaic = (): void => {
            mosaicLeft.value = props.compareMapbox.leftMosaic
                ? props.compareMapbox.leftMosaic
                : props.userMosaic;
            mosaicRight.value = props.compareMapbox.rightMosaic;

            if (props.compareMapbox.isCompareMosaic) {
                isComparingMosaicOn.value = true;
            }
        };

        onMounted(() => {
            assignMosaic();
        });

        return {
            mosaicLeft,
            mosaicRight,
            compareMosaic,
            clearCompareMosaic,
            isComparingMosaicOn,
        };
    },
});
